import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-486349e4")

_pushScopeId("data-v-486349e4")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen right-container" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-start bg-primary-100 overflow-y-scroll px-12 pt-12" }
const _hoisted_4 = { class: "panel-container rounded-md bg-white pb-2 mb-16" }
const _hoisted_5 = { class: "flex items-center justify-between w-full table-header-color px-4 py-3" }
const _hoisted_6 = { class: "mr-2" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "新しいジャーナルを登録", -1)
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "情報取得中...", -1)
const _hoisted_11 = { class: "hidden lg:flex justify-end items-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 選択したジャーナルを削除 ")
const _hoisted_13 = { class: "mr-6 text-gray-500 text-sm" }
const _hoisted_14 = {
  key: 1,
  class: "flex"
}
const _hoisted_15 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_16 = { class: "flex-grow flex items-start justify-center bg-primary-100 overflow-y-auto px-4 pt-12" }
const _hoisted_17 = { class: "w-full max-w-2xl rounded-md bg-white px-6 py-10 text-center shadow-sm" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h1", { class: "text-xl font-bold text-gray-800" }, " 成長ジャーナル管理画面が移動しました ", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "mt-4 text-gray-600 leading-7" }, [
  /*#__PURE__*/_createTextVNode(" 成長ジャーナルの確認・作成・編集は、"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" スクールAIの成長ジャーナル管理画面から行えます。 ")
], -1)
const _hoisted_20 = { class: "mt-8 flex justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_loading_icon = _resolveComponent("m-loading-icon")
  const _component_m_table = _resolveComponent("m-table")
  const _component_JournalAddModal = _resolveComponent("JournalAddModal")
  const _component_JournalEditModal = _resolveComponent("JournalEditModal")
  const _component_JournalAnalysisModal = _resolveComponent("JournalAnalysisModal")

  return (_ctx.isStudyRoomOnly)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_MNavBar),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_MHeaderPanel, {
              title: "成長ジャーナル管理",
              breadcrumbs: []
            }),
            _createVNode("main", _hoisted_3, [
              _createVNode("section", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword = $event)),
                      type: "search",
                      name: "searchMiniApp",
                      placeholder: "タイトルで検索...",
                      class: "w-44 md:w-60 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-2 leading-8 transition-colors duration-300"
                    }, null, 512), [
                      [_vModelText, _ctx.searchKeyword]
                    ])
                  ]),
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_m_button, {
                      color: "primary-500",
                      "hover-color": "primary-600",
                      onClick: _ctx.showAddModal
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_m_icon, {
                          type: "plus",
                          width: "4",
                          class: "mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                (_ctx.load)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode(_component_m_loading_icon),
                      _hoisted_10
                    ]))
                  : (_openBlock(), _createBlock(_component_m_table, {
                      key: 1,
                      datas: _ctx.filteredJournals,
                      definitions: _ctx.definitions,
                      "count-per-page": 40,
                      "default-sort-key": "title",
                      editable: true,
                      selectable: "",
                      "selected-ids": _ctx.selectedIds,
                      onChange: _ctx.changeSelectedId,
                      onSelect: _ctx.showEditModal,
                      onOnCustomButtonClick: _ctx.handleAiReflectionClick
                    }, {
                      footer: _withId(() => [
                        _createVNode("div", _hoisted_11, [
                          _createVNode(_component_m_button, {
                            color: "red-400",
                            "hover-color": "red-500",
                            outline: "",
                            class: "mr-6",
                            disabled: !_ctx.selectedIds.length,
                            onClick: _ctx.deleteSelectedJournals
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]),
                          _createVNode("p", _hoisted_13, _toDisplayString(_ctx.selectedIds.length) + "個を選択中 ", 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["datas", "definitions", "selected-ids", "onChange", "onSelect", "onOnCustomButtonClick"]))
              ])
            ])
          ])
        ]),
        (_ctx.displayAddModal)
          ? (_openBlock(), _createBlock(_component_JournalAddModal, {
              key: 0,
              students: _ctx.studentsOfSchool,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayAddModal = false)),
              onSyncAddition: _ctx.syncAddition
            }, null, 8, ["students", "onSyncAddition"]))
          : _createCommentVNode("", true),
        (_ctx.displayEditModal)
          ? (_openBlock(), _createBlock(_component_JournalEditModal, {
              key: 1,
              journal: _ctx.selectedJournal,
              students: _ctx.studentsOfSchool,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.displayEditModal = false)),
              onSyncUpdate: _ctx.syncUpdate
            }, null, 8, ["journal", "students", "onSyncUpdate"]))
          : _createCommentVNode("", true),
        (_ctx.displayAiModal)
          ? (_openBlock(), _createBlock(_component_JournalAnalysisModal, {
              key: 2,
              journal: _ctx.aiTargetJournal,
              students: _ctx.studentsOfSchool,
              prompt: _ctx.prompt ?? undefined,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.displayAiModal = false))
            }, null, 8, ["journal", "students", "prompt"]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createBlock("div", _hoisted_14, [
        _createVNode(_component_MNavBar),
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_MHeaderPanel, {
            title: "成長ジャーナル管理",
            breadcrumbs: []
          }),
          _createVNode("main", _hoisted_16, [
            _createVNode("section", _hoisted_17, [
              _hoisted_18,
              _hoisted_19,
              _createVNode("div", _hoisted_20, [
                _createVNode("a", {
                  href: _ctx.newJournalManagementUrl,
                  class: "inline-flex items-center rounded-md font-medium text-sm transition-all duration-300 px-4 py-2 text-white bg-primary-500 hover:bg-primary-600 cursor-pointer"
                }, " 新しい成長ジャーナル管理画面を開く ", 8, ["href"])
              ])
            ])
          ])
        ])
      ]))
})